import React from "react"

const Hero = ({data}) => {
  const {backgroundImage, title} = data
  const image = backgroundImage?.localFile?.childImageSharp?.fluid?.src
  const file = backgroundImage?.mediaItemUrl

  const source = image ? image : file

  return (
    <>
      {source && (
        <section
          className='page-hero background-image'
          style={{backgroundImage: `url(${source})`}}
        >
          {title && (
            <h1 className="hero-title">{title}</h1>
          )}
        </section>
      )}
    </>
  )
}

export default Hero
